import React, { useState, useEffect } from 'react';

const LegalTextPage = ({ slug }) => {
  const [text, setText] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api/v1/legal_texts/${slug}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) setText(data.legal_text);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [slug]);

  const colors = {
    primary: '#7c2837', primaryDark: '#5a1d28', text: '#2c0e16',
    textMuted: '#6c4a53', border: '#e8d0d6', card: '#ffffff',
  };

  const containerStyle = {
    maxWidth: 800, margin: '0 auto', padding: '30px 20px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", color: colors.text, minHeight: '80vh',
  };

  const headerStyle = {
    background: `linear-gradient(135deg, ${colors.primary}, ${colors.primaryDark})`,
    color: '#fff', padding: '35px 30px', borderRadius: 16, marginBottom: 30, textAlign: 'center',
  };

  const cardStyle = {
    background: colors.card, borderRadius: 12, padding: '30px 35px',
    boxShadow: '0 2px 12px rgba(124,40,55,0.08)', border: `1px solid ${colors.border}`,
    lineHeight: 1.7, fontSize: 15,
  };

  if (loading) {
    return (
      <div style={{ ...containerStyle, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <p style={{ color: colors.textMuted }}>⏳ Chargement...</p>
      </div>
    );
  }

  if (!text) {
    return (
      <div style={containerStyle}>
        <div style={{ ...cardStyle, textAlign: 'center', padding: 50 }}>
          <p style={{ fontSize: 16 }}>❌ Document non trouvé</p>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h1 style={{ margin: 0, fontSize: 26 }}>📜 {text.title}</h1>
        <p style={{ margin: '8px 0 0', opacity: 0.7, fontSize: 13 }}>
          Dernière mise à jour : {new Date(text.updated_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
        </p>
      </div>
      <div style={cardStyle} dangerouslySetInnerHTML={{ __html: text.content }} />
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <button onClick={() => window.history.back()}
          style={{
            padding: '10px 24px', borderRadius: 8, border: `1px solid ${colors.primary}`,
            background: 'transparent', color: colors.primary, cursor: 'pointer', fontSize: 14, fontWeight: 600,
          }}>
          ← Retour
        </button>
      </div>
    </div>
  );
};

export default LegalTextPage;
